
  import { Component, Vue } from "vue-property-decorator";
  import api from "@/api/index";
  import moment from "moment";
  import PagedTableView from "@/components/PagedTableView/index.vue";
  import UseUserCard from "@/views/cards/components/use-userCard.vue";
  import {OrganizationWechatUserDto, UserBabyDetail} from "@/api/appService";
  import DiffCardRefundDialog from "@/views/ou/components/DiffCardRefundDialog.vue";

  @Component({
    name: "UserList",
    components: {DiffCardRefundDialog, UseUserCard, PagedTableView}
  })
  export default class extends Vue {



    queryForm = {
      keyword: "" ,
      babyName:'',
      babyNickName:'',
      contactName:"",
      isGetUserVipCardBalance:true,
      isGetUserDiffCardBalance:true
    };

    formatBabyContact(babyDetail:UserBabyDetail){
      if(!babyDetail){
        return '暂未填写';
      }
      return `${babyDetail.contactName}(${babyDetail.contactDesc})<br>手机:${babyDetail.contactPhone}`
    }



    formatBabyBirthday(dto:OrganizationWechatUserDto){
      if(dto && dto.user && dto.user.babyDetail && dto.user.babyDetail.birthday){
        return (moment(dto.user.babyDetail.birthday)).format('YYYY-MM-DD')
      } else {
        return '';
      }
    }

    fetchData(params:any){
      return api.user.getAllOrganizationWechatUser(params);
    }

    handleActionCommand(index: number, row:any,command:string){
      console.log('command',command,'row',row,'index',index);
      switch (command){
        case 'use':
          this.handleUse(row);
          break;
        case 'viewCards':
          this.handleViewCards(index,row);
          break;
        case 'refundDiffCard':
          this.handleRefundDiffCard(row);
          break;
      }
    }

    handleViewCards(index:number,row:any){
      this.$router.push({
        name:'userCardsOfUserId',
        params:{userId:row.user.id}
      });
    }

    handleUse(row:OrganizationWechatUserDto){
      (this.$refs.useUserCard as any).userId = row.user!.id!;
      (this.$refs.useUserCard as any).show = true;
      (this.$refs.useUserCard as any).input = {creatorUserId:row.user!.id,id:0};
    }
    handleRefundDiffCard(row:OrganizationWechatUserDto){
      (this.$refs.diffCardRefundDialog as any).show = true;
      (this.$refs.diffCardRefundDialog as any).userId = row.user!.id!;
    }


    handleViewDetail(index:number, row:any){
      this.$router.push({
        name:'user-detail',
        params:{id:row.user.id}
      })
    }

  }
